export const CarouselImages = [
    { source:'./assets/GalleryImages/BRK_3548.jpg' },
    { source:'./assets/GalleryImages/BRK_3633a.jpg' },
    { source:'./assets/GalleryImages/BRK_3994-Edit.jpg' },
    { source:'./assets/GalleryImages/BRK_6046.jpg' },
    { source:'./assets/GalleryImages/BRK_6580.jpg' },
    { source:'./assets/GalleryImages/BRK_6638.jpg' },
    { source:'./assets/GalleryImages/IMG-20210211-WA0002.jpg' },
    { source:'./assets/GalleryImages/IMG-20220412-WA0043.jpg' },
]